import React from 'react';
import AssessmentResources from '@src/modules/accounts/components/AssessmentResources';

export function AssessmentCreateTab({formik}) {
    return <AssessmentResources formik={formik} />;
}
